/*
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */

import {
  ExtensibleProps as ExtensibleReactHostProps,
  Extensible as ExtensibleReactHost,
  InstalledExtensions
} from '@adobe/uix-host-react'
import { PropsWithChildren, useMemo } from 'react'

interface ExtensibleProps
  extends Omit<ExtensibleReactHostProps, 'extensionsProvider'> {
  extensions: InstalledExtensions
}

export const Extensible = (props: PropsWithChildren<ExtensibleProps>) => {
  const extensionsProvider = useMemo(() => {
    return async () => {
      return props.extensions
    }
  }, [props.extensions])
  const extensibleProps: PropsWithChildren<ExtensibleReactHostProps> = {
    ...props,
    extensionsProvider
  }

  return (
    <ExtensibleReactHost {...extensibleProps}>
      {props.children}
    </ExtensibleReactHost>
  )
}
